import { useQuery } from '@apollo/client';
import { Grid } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import * as React from 'react';
import { compose } from 'recompose';
import { Loader } from '@topconagriculture/loader';
import { withBaseProps } from '../Utils';
import { DataTable } from './';
const DEFAULT_PAGE_SIZE = 20;
const styles = createStyles({
    loaderContainer: {
        height: '100%',
    },
});
const DataTableWithQuery = (props) => {
    const { tableId, classes, errorMessage, EmptyListComponent, displayError, ActionComponent, title, defaultFilterTitle, entityName, pageSize = DEFAULT_PAGE_SIZE, queryParams, query, columns, filterGroups, pageInfoEndCursorKey = 'endCursor', dataFilter = () => true, emptyValue, dataMapper = (value) => value, selectable, selectionMapper, FooterComponent, className, } = props;
    const { data, loading, error, fetchMore } = useQuery(query, {
        variables: { first: pageSize, ...queryParams },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
    });
    const mappedDataEdges = (data &&
        data[entityName] &&
        data[entityName].edges &&
        data[entityName].edges.map((edge) => dataMapper(edge.node)).filter(dataFilter)) ||
        [];
    const isLoading = loading && !mappedDataEdges.length;
    const isNoDataAvailable = !loading && !mappedDataEdges.length;
    if (isLoading) {
        return (React.createElement(Grid, { container: true, alignItems: "center", justifyContent: "center", className: classes.loaderContainer },
            React.createElement(Loader, null)));
    }
    if (error && typeof displayError === 'function') {
        displayError(errorMessage);
    }
    if (isNoDataAvailable) {
        return React.createElement(EmptyListComponent, null);
    }
    return (React.createElement(DataTable, { tableId: tableId, className: className, ActionComponent: ActionComponent, FooterComponent: FooterComponent, title: title, columns: columns, data: mappedDataEdges, defaultFilterTitle: defaultFilterTitle, filterGroups: filterGroups, pageInfo: data[entityName].pageInfo, isLoading: loading, emptyValue: emptyValue, selectable: selectable, selectionMapper: selectionMapper, loadMore: () => fetchMore({
            query: query,
            variables: {
                first: pageSize,
                after: data[entityName].pageInfo[pageInfoEndCursorKey],
                ...queryParams,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                if (!fetchMoreResult) {
                    if (typeof displayError === 'function') {
                        displayError(errorMessage);
                    }
                    return previousResult;
                }
                const result = fetchMoreResult[entityName];
                const prevResult = previousResult[entityName];
                const edges = [...prevResult.edges, ...result.edges];
                return {
                    [entityName]: {
                        ...result,
                        edges,
                    },
                };
            },
        }) }));
};
export default compose(withBaseProps({ styles }))(DataTableWithQuery);
//# sourceMappingURL=DataTableWithQuery.js.map